import Api from '../../helpers/api';
import Locations from '../../helpers/locations';
import Constants from './NewCovidConstant';

export const getCovidpackage = (search,city) => {
console.log(city)
const params = {  
    search,
    city
}
    return function (dispatch) {
            dispatch({
                type: Constants.ACTIONS.GET_COVIDPACK_LOADING,                
            });
        const successCall = (response) => { 
            console.log(response)
            dispatch({
                type: Constants.ACTIONS.GET_COVIDPACK,
                payload: response.results
            });
        };

        const errorCall = (errorResponse) => {
            console.log(errorResponse)
            dispatch({
                type: Constants.ACTIONS.GET_COVIDPACK_FAIL,
                payload: errorResponse
            });
        }

        Api.doGet(Locations.PACKAGE, params, successCall, errorCall);
    }
}


export default {
    getCovidpackage,
}